export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_FAILTURE = "LOGIN_FAILTURE";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOGOUT = "LOGOUT";